<template>
    <el-card >
      <el-form
        :model="formData"
        :rules="rules"
        ref="ruleForm"
        label-suffix=":"
        class="demo-ruleForm"
      >
        <el-form-item class="input_right" label="大楼" prop="addressPrefix">
          <el-select
            v-model="formData.addressPrefix"
            filterable
            style="width: 100%;"
            placeholder="请选择大楼"
            @change="val=>{getOption('unitOptions',{three: this.$route.query.three,addressPrefix:val},'unit')}"
          >
            <el-option
              v-for="item in addressPrefixOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="input_right" label="单元" prop="unit">
          <el-select
            v-model="formData.unit"
            filterable
            style="width: 100%;"
            placeholder="请选择单元"
            @change="val=>{getOption('mpOptions',{three: this.$route.query.three,addressPrefix:this.formData.addressPrefix,unit:val},'mp')}"
          >
            <el-option
              v-for="item in unitOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="input_right" label="门牌" prop="mp">
          <el-select
            v-model="formData.mp"
            filterable
            style="width: 100%;"
            placeholder="请选择门牌"
          >
            <el-option
              v-for="item in mpOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="input_right" label="选择分组" >
          <el-select placeholder="选择分组" v-model="fz" style="width: 100%;">
            <el-option label="我家" value="我家"></el-option>
            <el-option label="父母" value="父母"></el-option>
            <el-option label="朋友" value="朋友"></el-option>
            <el-option label="房东" value="房东"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <button @click="searchUser" style="width: 100%;" class="btn_bind">
        查 询
      </button>
    </el-card>

</template>

<script>
  import {findCascadeMp} from "@/api";

  export default {
    data() {
      return {
        formData: {

        },
        fz: '我家',
        addressPrefixOptions: [],
        unitOptions: [],
        mpOptions: [],
        relationShip: '我家',
        sexVisible: false,  //选择器的显示与隐藏
        slots: [
          {
            flex: 1,
            values: ['我家', '父母', '房东', '朋友'],
            className: 'slot1',
            textAlign: 'center',
          }
        ],
        rules: {
          mp: [
            {
              required: true, message: '请选择门牌号'
            },
          ],
          unit: [
            {
              required: true, message: '请选择单元'
            },
          ],
          addressPrefix: [
            {
              required: true, message: '请选择大楼'
            },
          ],
        }
      }
    },
    mounted() {
      this.getOption('addressPrefixOptions',{three: this.$route.query.three,},'addressPrefix')
    },
    methods: {
      onValuesChange(picker, values) {
        this.relationShip = values[0];
        this.sexVisible = false;
      },
      getOption(optionsKey,params,key) {
        if(key=='unit') {
          delete this.formData.unit
          delete this.formData.mp
        }
        if(key=='mp') {
          delete this.formData.mp
        }
        params.key = key
        findCascadeMp(params).then(res=>{
          this[optionsKey] = [];
          res.data.map(v=>{
            this[optionsKey].push({label: v,value: v})
          })
        })
      },
      searchUser() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.formData.three = this.$route.query.three
            this.$router.push({
              path: '/bindList',
              query: {
                fz: this.fz,
                params: JSON.stringify(this.formData),
                type: 1
              }
            })
          }
        })

      }
    }
  }
</script>

<style>
  div_fenzu {
    width: 100%;
    display: flex;
    justify-content: space-between;
    background: #fff;
    line-height: 43px;
    /* padding: 0 3%; */

  }

  .tit_tip {
    margin: 5px 2%;
    color: #8c939d;
  }
</style>



// WEBPACK FOOTER //
// src/view/yhBind/bindUserTj.vue